<div class="container-fluid py-4">
  <div class="row mb-4 justify-content-center">
    <ng-container *ngFor="let card of resumenCards; index as i">
      <div class="col-3 col-md-2">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 2 }"
          [routerLink]="card.route"
          [style.cursor]="card.route || i === 2 ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow icon-card"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>

              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- SALTO DE FILA después de la 4ta tarjeta (i = 3) -->
      <div *ngIf="i === 3" class="w-100"></div>
    </ng-container>
  </div>
  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a class="btn btn-dark btn-sm btn-reg" [routerLink]="['/observability/social']">Social Main</a>
        <a class="btn btn-dark btn-sm btn-new ms-2" [routerLink]="['/observability/social/audits']">Audits & Incidents</a>
        <a class="btn btn-dark btn-sm btn-new ms-2" [routerLink]="['/observability/social/executive']">Executive View</a>
        <a class="btn btn-dark btn-sm btn-new ms-2" [routerLink]="['/observability/social/leads']">Leads & Community</a>
      </div>
    </div>
  </div>
  <br>
  <div >
    <!--  Health State Banner  -->
    <div class="health-banner" [ngClass]="healthBadge.badgeClass">
      <i class="fas fa-heartbeat fa-lg"></i>
      <span class="health-label">{{ healthBadge.label }}</span>
      <span *ngFor="let signal of activeSignals" class="signal-pill">
        <i class="fas fa-exclamation-triangle me-1"></i>{{ signal }}
      </span>
      <span *ngIf="safeStateActive" class="signal-pill">
        <i class="fas fa-shield-alt me-1"></i>Safe State Active
      </span>
    </div>

    <!--  Section Tabs  -->
    <div class="section-tabs">
      <button
        class="btn-tab"
        [class.active]="activeSection === 'output'"
        (click)="setSection('output')"
      >
        <i class="fas fa-paper-plane me-1"></i> Output KPIs
      </button>
      <button
        class="btn-tab"
        [class.active]="activeSection === 'distribution'"
        (click)="setSection('distribution')"
      >
        <i class="fas fa-eye me-1"></i> Distribution
      </button>
      <button
        class="btn-tab"
        [class.active]="activeSection === 'conversion'"
        (click)="setSection('conversion')"
      >
        <i class="fas fa-funnel-dollar me-1"></i> Conversion
      </button>
      <button
        class="btn-tab"
        [class.active]="activeSection === 'quality'"
        (click)="setSection('quality')"
      >
        <i class="fas fa-star me-1"></i> Quality
      </button>
      <button
        class="btn-tab"
        [class.active]="activeSection === 'health'"
        (click)="setSection('health')"
      >
        <i class="fas fa-heartbeat me-1"></i> Health State
      </button>
      <button
        class="btn-tab"
        [class.active]="activeSection === 'reason'"
        (click)="setSection('reason')"
      >
        <i class="fas fa-list-ul me-1"></i> Reason Codes
      </button>
      <button
        class="btn-tab"
        [class.active]="activeSection === 'touchbase'"
        (click)="setSection('touchbase')"
      >
        <i class="fas fa-stopwatch me-1"></i> Touch Base
      </button>
      <button
        class="btn-tab"
        [class.active]="activeSection === 'inventory'"
        (click)="setSection('inventory')"
      >
        <i class="fas fa-boxes me-1"></i> Inventory
      </button>
    </div>

    <!--  Search bar  -->
    <div class="row mb-3">
      <div class="col-md-4">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Search by platform, period, health…"
            [(ngModel)]="searchText"
            (ngModelChange)="filterInfo()"
            autocomplete="off"
          />
          <span class="input-group-text bg-transparent">
            <i class="fas fa-search text-dark"></i>
          </span>
        </div>
      </div>
      <div class="col-md-3 d-flex align-items-center">
        <span *ngIf="loading" class="text-muted ms-2">
          <i class="fas fa-spinner fa-spin me-1"></i> Loading…
        </span>
      </div>
    </div>

    <!--  OUTPUT KPIs  -->
    <ng-container *ngIf="activeSection === 'output'">
      <h6 class="text-muted text-uppercase mb-3 fw-bold">
        <i class="fas fa-paper-plane me-2"></i>Output KPIs
      </h6>
      <div class="kpi-grid mb-4">
        <div
          class="kpi-card"
          *ngFor="let k of outputKpis"
          [style.borderLeftColor]="k.color"
        >
          <i [class]="k.icon + ' kpi-icon'" [style.color]="k.color"></i>
          <div class="kpi-value">{{ formatValue(k.value) }}</div>
          <div class="kpi-label">{{ k.label }}</div>
        </div>
      </div>

      <!-- Output table -->
      <div class="table-responsive">
        <table class="obs-table">
          <thead>
            <tr>
              <th>KPI</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let k of outputKpis">
              <td>
                <i [class]="k.icon + ' me-2'" [style.color]="k.color"></i
                >{{ k.label }}
              </td>
              <td>
                <strong>{{ formatValue(k.value) }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!--  DISTRIBUTION KPIs  -->
    <ng-container *ngIf="activeSection === 'distribution'">
      <h6 class="text-muted text-uppercase mb-3 fw-bold">
        <i class="fas fa-eye me-2"></i>Distribution KPIs
      </h6>
      <div class="kpi-grid mb-4">
        <div
          class="kpi-card"
          *ngFor="let k of distributionKpis"
          [style.borderLeftColor]="k.color"
        >
          <i [class]="k.icon + ' kpi-icon'" [style.color]="k.color"></i>
          <div class="kpi-value">{{ formatValue(k.value, k.isPercent) }}</div>
          <div class="kpi-label">{{ k.label }}</div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="obs-table">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let k of distributionKpis">
              <td>
                <i [class]="k.icon + ' me-2'" [style.color]="k.color"></i
                >{{ k.label }}
              </td>
              <td>
                <strong>{{ formatValue(k.value, k.isPercent) }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!--  CONVERSION KPIs  -->
    <ng-container *ngIf="activeSection === 'conversion'">
      <h6 class="text-muted text-uppercase mb-3 fw-bold">
        <i class="fas fa-funnel-dollar me-2"></i>Conversion KPIs
      </h6>
      <div class="kpi-grid mb-4">
        <div
          class="kpi-card"
          *ngFor="let k of conversionKpis"
          [style.borderLeftColor]="k.color"
        >
          <i [class]="k.icon + ' kpi-icon'" [style.color]="k.color"></i>
          <div class="kpi-value">{{ formatValue(k.value) }}</div>
          <div class="kpi-label">{{ k.label }}</div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="obs-table">
          <thead>
            <tr>
              <th>Action</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let k of conversionKpis">
              <td>
                <i [class]="k.icon + ' me-2'" [style.color]="k.color"></i
                >{{ k.label }}
              </td>
              <td>
                <strong>{{ formatValue(k.value) }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!--  QUALITY KPIs  -->
    <ng-container *ngIf="activeSection === 'quality'">
      <h6 class="text-muted text-uppercase mb-3 fw-bold">
        <i class="fas fa-star me-2"></i>Quality KPIs
      </h6>
      <div class="kpi-grid mb-4">
        <div
          class="kpi-card"
          *ngFor="let k of qualityKpis"
          [style.borderLeftColor]="k.color"
        >
          <i [class]="k.icon + ' kpi-icon'" [style.color]="k.color"></i>
          <div class="kpi-value">{{ formatValue(k.value, true) }}</div>
          <div class="kpi-label">{{ k.label }}</div>
        </div>
      </div>

      <!-- Quality table with progress bars -->
      <div class="table-responsive">
        <table class="obs-table">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Rate</th>
              <th class="bar-cell">Distribution</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let k of qualityKpis">
              <td>
                <i [class]="k.icon + ' me-2'" [style.color]="k.color"></i
                >{{ k.label }}
              </td>
              <td>
                <strong>{{ formatValue(k.value, true) }}</strong>
              </td>
              <td class="bar-cell">
                <div class="progress">
                  <div
                    class="progress-bar"
                    [style.width.%]="k.value * 100"
                    [style.backgroundColor]="k.color"
                  ></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!--  HEALTH STATE  -->
    <ng-container *ngIf="activeSection === 'health'">
      <h6 class="text-muted text-uppercase mb-3 fw-bold">
        <i class="fas fa-heartbeat me-2"></i>Health State
      </h6>

      <div class="table-responsive">
        <table class="obs-table">
          <thead>
            <tr>
              <th>State</th>
              <th>Description</th>
              <th>Active?</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of healthStateMap | keyvalue">
              <td>
                <span
                  class="badge rounded-pill"
                  [ngClass]="entry.value.badgeClass"
                  style="font-size: 0.8rem; padding: 4px 10px"
                >
                  {{ entry.value.label }}
                </span>
              </td>
              <td class="text-muted">{{ entry.key }}</td>
              <td>
                <i
                  class="fas"
                  [class.fa-check-circle]="healthState === entry.key"
                  [class.fa-circle]="healthState !== entry.key"
                  [style.color]="
                    healthState === entry.key ? '#28a745' : '#ced4da'
                  "
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-3">
        <strong class="text-muted text-uppercase" style="font-size: 0.8rem"
          >Active Signals</strong
        >
        <div class="mt-2">
          <span
            *ngFor="let s of activeSignals"
            class="badge rounded-pill bg-warning text-dark me-2 mb-2"
            style="font-size: 0.82rem"
          >
            <i class="fas fa-exclamation-triangle me-1"></i>{{ s }}
          </span>
          <span *ngIf="!activeSignals.length" class="text-muted"
            >No active signals</span
          >
        </div>
      </div>
    </ng-container>

    <!--  REASON CODES / INVALID REASON DISTRIBUTION  -->
    <ng-container *ngIf="activeSection === 'reason'">
      <h6 class="text-muted text-uppercase mb-3 fw-bold">
        <i class="fas fa-list-ul me-2"></i>Invalid Reason Distribution
      </h6>

      <div class="row mb-4">
        <div class="col-md-6">
          <div class="table-responsive">
            <table class="obs-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Reason Code</th>
                  <th>Count</th>
                  <th class="bar-cell">Share</th>
                </tr>
              </thead>
              <tbody>
                <ng-container
                  *ngIf="invalidReasonDistribution.length; else noReasons"
                >
                  <tr *ngFor="let r of invalidReasonDistribution; index as i">
                    <td class="text-muted">{{ i + 1 }}</td>
                    <td>
                      <span class="badge rounded-pill bg-secondary">{{
                        r.reason
                      }}</span>
                    </td>
                    <td>
                      <strong>{{ r.count }}</strong>
                    </td>
                    <td class="bar-cell">
                      <div class="progress">
                        <div
                          class="progress-bar bg-danger"
                          [style.width.%]="
                            totalInvalidCount() > 0
                              ? (r.count / totalInvalidCount()) * 100
                              : 0
                          "
                        ></div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
                <ng-template #noReasons>
                  <tr>
                    <td colspan="4" class="text-center text-muted py-3">
                      No invalid reason data
                    </td>
                  </tr>
                </ng-template>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-md-6">
          <div class="kpi-grid">
            <div
              *ngFor="let r of invalidReasonDistribution"
              class="kpi-card"
              style="border-left-color: #dc3545"
            >
              <i class="fas fa-ban kpi-icon" style="color: #dc3545"></i>
              <div class="kpi-value">{{ r.count }}</div>
              <div class="kpi-label">{{ r.reason }}</div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!--  TOUCH BASE RESPONSE TIME  -->
    <ng-container *ngIf="activeSection === 'touchbase'">
      <h6 class="text-muted text-uppercase mb-3 fw-bold">
        <i class="fas fa-stopwatch me-2"></i>Touch Base Response Time
      </h6>

      <div class="time-row mb-4">
        <div class="time-card">
          <div class="kpi-label mb-1">Avg Response Time</div>
          <div class="time-value">{{ responseTimeAvg }}</div>
          <div class="time-unit">minutes</div>
        </div>
        <div class="time-card" style="border-left-color: #fd7e14">
          <div class="kpi-label mb-1">P95 Response Time</div>
          <div class="time-value" style="color: #fd7e14">
            {{ responseTimeP95 }}
          </div>
          <div class="time-unit">minutes</div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="obs-table">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Value (min)</th>
              <th class="bar-cell">Gauge</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <i class="fas fa-stopwatch me-2" style="color: #455e72"></i
                >Average Response Time
              </td>
              <td>
                <strong>{{ responseTimeAvg }}</strong>
              </td>
              <td class="bar-cell">
                <div class="progress">
                  <div
                    class="progress-bar"
                    style="background: #455e72"
                    [style.width.%]="
                      responseTimeAvg >= 60 ? 100 : (responseTimeAvg / 60) * 100
                    "
                  ></div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <i class="fas fa-tachometer-alt me-2" style="color: #fd7e14"></i
                >P95 Response Time
              </td>
              <td>
                <strong>{{ responseTimeP95 }}</strong>
              </td>
              <td class="bar-cell">
                <div class="progress">
                  <div
                    class="progress-bar bg-warning"
                    [style.width.%]="
                      responseTimeP95 >= 60 ? 100 : (responseTimeP95 / 60) * 100
                    "
                  ></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <!--  INVENTORY LOW / REFRESH BACKLOG  -->
    <ng-container *ngIf="activeSection === 'inventory'">
      <h6 class="text-muted text-uppercase mb-3 fw-bold">
        <i class="fas fa-boxes me-2"></i>Inventory Low / Refresh Backlog
      </h6>

      <div class="inv-row mb-4">
        <div class="inv-card">
          <div class="inv-card-title">
            <i class="fas fa-box-open me-1"></i>Inventory Ready
          </div>
          <div class="time-value" style="color: #28a745">
            {{ inventoryReady }}
          </div>
          <div class="time-unit">posts ready</div>
          <div class="progress mt-2">
            <div
              class="progress-bar bg-success"
              [style.width.%]="
                (inventoryReady / (inventoryReady + refreshDue || 1)) * 100
              "
            ></div>
          </div>
        </div>

        <div class="inv-card">
          <div class="inv-card-title">
            <i class="fas fa-sync-alt me-1"></i>Refresh Due (Backlog)
          </div>
          <div class="time-value" style="color: #dc3545">{{ refreshDue }}</div>
          <div class="time-unit">posts need refresh</div>
          <div class="progress mt-2">
            <div
              class="progress-bar bg-danger"
              [style.width.%]="
                (refreshDue / (inventoryReady + refreshDue || 1)) * 100
              "
            ></div>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="obs-table">
          <thead>
            <tr>
              <th>State</th>
              <th>Count</th>
              <th class="bar-cell">Share</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <i class="fas fa-box-open me-2" style="color: #28a745"></i
                >Inventory Ready
              </td>
              <td>
                <strong>{{ inventoryReady }}</strong>
              </td>
              <td class="bar-cell">
                <div class="progress">
                  <div
                    class="progress-bar bg-success"
                    [style.width.%]="
                      (inventoryReady / (inventoryReady + refreshDue || 1)) *
                      100
                    "
                  ></div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <i class="fas fa-sync-alt me-2" style="color: #dc3545"></i
                >Refresh Due
              </td>
              <td>
                <strong>{{ refreshDue }}</strong>
              </td>
              <td class="bar-cell">
                <div class="progress">
                  <div
                    class="progress-bar bg-danger"
                    [style.width.%]="
                      (refreshDue / (inventoryReady + refreshDue || 1)) * 100
                    "
                  ></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>
</div>
